import type { ReactNode } from "react";
import type { ClientAvailability } from "../lib/types";
import { cn } from "../lib/utils";

interface DashboardShellProps {
  navigationRail: ReactNode;
  header: ReactNode;
  trustStatus: ReactNode;
  filterPanel: ReactNode;
  inspector?: ReactNode;
  children: ReactNode;
  dashboardState: ClientAvailability;
  indexedRowCount?: number;
}

export function DashboardShell({
  navigationRail,
  header,
  trustStatus,
  filterPanel,
  inspector,
  children,
  dashboardState,
  indexedRowCount
}: DashboardShellProps) {
  return (
    <main
      className="h-screen min-h-[560px] overflow-hidden bg-background text-foreground"
      data-dashboard-state={dashboardState}
      data-indexed-row-count={indexedRowCount}
    >
      <div className="grid h-full grid-cols-[48px_minmax(0,1fr)]">
        {navigationRail}

        <section className="grid min-w-0 grid-rows-[48px_34px_minmax(0,1fr)]">
          {header}
          {trustStatus}

          <div className="flex min-h-0 min-w-0">
            {filterPanel}
            <section className="min-w-0 flex-1 overflow-y-auto bg-background p-2">
              {children}
            </section>
            <aside
              aria-label={inspector ? "Transaction inspector" : undefined}
              aria-hidden={inspector ? undefined : true}
              className={cn(
                "hidden shrink-0 overflow-hidden bg-surface transition-[width] duration-150 min-[1600px]:block",
                inspector ? "w-[400px] border-l border-border" : "w-0 border-l-0"
              )}
            >
              {inspector}
            </aside>
          </div>
        </section>
      </div>
    </main>
  );
}
